module.exports = __webpack_public_path__ + "img/f1.2e3b255.png";